<template>
  <div>
    <input class="mb-2" placeholder="Digite o código do cliente..." v-model="clientId"/><button class="btn-search" @click="findByClientId">Buscar</button>
    <card title="Lista de Contratos" subTitle="Lista de todos os contratos gerados">
      <div slot="raw-content" class="table-responsive">
        <table class="table table-striped">
          <thead>
            <th>ID Contrato</th>
            <th>Nome Contrato</th>
            <th>ID Cliente</th>
            <th>ID Ponto</th>
            <th>Assinado</th>
            <th>Data Criação</th>
            <th>Criado por</th>
            <th>Ações</th>
          </thead>
          <tbody>
            <tr v-for="contract in contracts" :key="contract.id">
              <td>{{ contract.id }}</td>
              <td>{{ contract.name }}</td>
              <td>{{ contract.clientId }}</td>
              <td>{{ contract.pointId }}</td>
              <td>{{ contract.signedAt ? 'Sim' : 'Não' }}</td>
              <td>{{ formatDate(contract.createdAt) }}</td>
              <td>{{ contract.user.name }}</td>
              <td>
                <p-button type="info" outline icon title="Visualizar Contrato" @click.prevent.native="openContract(contract.id)">
                  <i class="fa fa-eye"></i>
                </p-button>
                <p-button class="btn-delete" type="danger" outline icon title="Apagar Contrato" @click.prevent.native="deleteRow(contract.id)" :disabled="contract.signedAt && !['admin', 'supervisor'].includes(userRole)">
                  <i class="fa fa-ban btn-delete"></i>
                </p-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </card>
  </div>
</template>

<script>
import { formatDistance } from "date-fns";
import pt from "date-fns/locale/pt-BR";
import Swal from "sweetalert2";
import { mapActions } from "vuex";

export default {
  computed: {
    contracts() {
      return this.$store.getters.contracts;
    },
    userRole() {
      return this.$store.getters.user.role;
    }
  },
  data() {
    return {
      clientId: '',
    };
  },
  methods: {
    ...mapActions(["fetchContractsByClientId", "deleteContract", "openContract"]),
    formatDate(date) {
      return formatDistance(new Date(date), new Date(), {
        locale: pt,
        addSuffix: true,
      });
    },
    async deleteRow(id) {
      const result = await Swal.fire({
        title: "Atenção!",
        text:
          "Esta ação irá apagar o contrato, deseja prosseguir?",
        icon: "warning",
        focusConfirm: false,
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#9dcf6b",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim",
        cancelButtonText: "Não"
      });

      if (result.isConfirmed) {
        try {
          await this.deleteContract({ id });
          Swal.fire({
            title: "Sucesso!",
            text: "Contrato apagado com sucesso",
            icon: "success"
          });
        } catch (e) {
          Swal.fire({
            title: "Ops!",
            text: "Não foi possível apagar o contrato",
            icon: "error"
          });
        }
      }
    },
    async findByClientId() {
      if (this.clientId.length < 1) {
        return;
      }

      try {
        await this.fetchContractsByClientId({ id: this.clientId });
      } catch (e) {
        Swal.fire({
          title: "Ops!",
          text: "Não foi possível carregar contratos",
          icon: "error"
        });
      }
    }
  }
};
</script>

<style scoped>
input {
  padding: 5px;
  width: 15rem;
}
button.btn-search {
  border: none;
  border: 1px solid;
  background: #9DCF6B;
  padding: 6px;
}
.btn-delete:disabled {
  cursor: not-allowed;
}
.btn-delete:hover:disabled {
  color: #dc3545;
}
</style>
